import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'
import HomePage from './pages/HomePage'
import LoginPage from './components/Login'
import FormView from './lib/rd-forms/forms/FormView.vue'
import DesignPage from './pages/DesignPage.vue'
import UpdatePassword from './pages/UpdatePassword'

Vue.use(Router)
let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: LoginPage,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/',
      name: 'HomePage',
      component: HomePage,
      meta: {
        requiresAuth: true
      },
      children: [
        // nu avem voie sa avem doua componente cu acelasi nume chiar daca difera path
        {
          path: '/formView/:entityId/:formType/:entryId',
          name: 'UpdateForm',
          component: FormView,
          props: true,
          meta: {
            requiresAuth: true
          }
        },

        {
          path: '/formView/:entityId/:formType/',
          name: 'FormView',
          component: FormView,
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/profile/update-password',
          name: 'UpdatePassword',
          component: UpdatePassword,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/design',
          name: 'DesignPage',
          component: DesignPage
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/login')
  } else {
    next()
  }
})

export default router
